import { render, staticRenderFns } from "./EditArea.vue?vue&type=template&id=717e1364"
import script from "./EditArea.vue?vue&type=script&lang=js"
export * from "./EditArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports